<template>
    <div class="base-mit-volume-analytics-time">
        <v-card flat>
            <v-row class="pa-4" justify="space-between">
                <v-col cols="12">
                    <v-card flat>
                        <canvas :id="chartId"></canvas>
                    </v-card>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
// import Chart from 'chart.js/auto';
// import moment from 'moment';
import Chart from 'chart.js/auto';
import 'chartjs-adapter-moment';


export default {
  name: 'MitVolumesAnalyticsTime',
  components: {
  },
  props: {
    chartId:{
          default:'mit_linebarchart',
          type:String
    },
    data: {
      default: {
          datasets:null,
          title:'title',
          labelX:'',
          labelY:''
      },
      type: Object
    },
    useTimeScaleX:{
        default:false,
        type:Boolean
    },
    scaleOverride:{
      default:null,
      type:String
    },
    chartType:{
          default:'line',
          type:String
      }
  },
  data: function() {
    return {
        colors:[
        'rgba(255, 99, 132, 1)',
        'rgba(54, 162, 235, 1)',
        'rgba(255, 206, 86, 1)',
        'rgba(75, 192, 192, 1)',
        'rgba(153, 102, 255, 1)']
    }
  },
  created() {
  },
  mounted() {

      this.data.datasets.forEach((ds, index, arr)=>{
          ds.borderColor = this.colors[index];
          ds.backgroundColor = this.colors[index];
      });

    const ctxLine = document.getElementById(this.chartId);
    
    let config = {
      type: this.chartType,
      data: this.data,
      options: {
          responsive: true,
          plugins: {
            title: {
              display: true,
              text: this.data.title
            }
          }
      }
    };

    if(this.useTimeScaleX){
      config.options.scales = {
            x: {
              type: 'time'
            }
        }
    }

    if(this.scaleOverride){
      config.options.scales = this.scaleOverride
    }

    let chart = new Chart(ctxLine, config);

  },
  methods : {
    nodeClicked(node){

    }
  }
}
</script>

<style lang="scss" scoped>

</style>
